export const blockIconsAudioandvideoMicOffNew = (
	<span className='material-symbols-outlined'>mic_off</span>
);
